import React from 'react';
import logo from '../logo.svg';
import '../stylesheets/App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
         Preparada para programar!
        </p>
      </header>
    </div>
  );
}

export default App;
